import script from "./SignInCodePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInCodePage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInCodePage.vue?vue&type=style&index=0&id=061c42c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061c42c4"]])

export default __exports__